import axios from 'axios';
import request, { createAvatar as getOptions } from '../requests.mjs';

export async function createAvatar(auth, data) {
  try {
    const response = await request(getOptions(auth, data));
    return [response.data, null];
  } catch (err) {
    console.log(err);
    return [null, err];
  }
}

export async function uploadAvatar(url, file) {
  try {
    const response = await axios.put(url, file, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return [true, null];
  } catch (err) {
    console.log(err);
    return [null, 'Your profile image was not uploaded.'];
  }
}
